import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';

// The library screen: the games of the last 30 days, the window the whole
// app covers (older games stay in storage, unread). The `library` layout
// with its toolbar row bound to the screen's header slot, holding the same top
// bar as every screen on the rail ("Library · Last 30 days" and the
// importer), and its list region bound to
// the games slot. Navigation is the rail's.
const bind = {
  toolbar: 'library.header',
  filters: 'library.filters',
  games: 'library.games',
};

// Phosphor database, the library entry on the navigation rail: where the
// games are kept.
const DATABASE =
  'M128,24C74.17,24,32,48.6,32,80v96c0,31.4,42.17,56,96,56s96-24.6,96-56V80C224,48.6,181.83,24,128,24Zm80,104c0,9.62-7.88,19.43-21.61,26.92C170.93,163.35,150.19,168,128,168s-42.93-4.65-58.39-13.08C55.88,147.43,48,137.62,48,128V111.36c17.06,15,46.23,24.64,80,24.64s62.94-9.68,80-24.64ZM69.61,53.08C85.07,44.65,105.81,40,128,40s42.93,4.65,58.39,13.08C200.12,60.57,208,70.38,208,80s-7.88,19.43-21.61,26.92C170.93,115.35,150.19,120,128,120s-42.93-4.65-58.39-13.08C55.88,99.43,48,89.62,48,80S55.88,60.57,69.61,53.08ZM186.39,202.92C170.93,211.35,150.19,216,128,216s-42.93-4.65-58.39-13.08C55.88,195.43,48,185.62,48,176V159.36c17.06,15,46.23,24.64,80,24.64s62.94-9.68,80-24.64V176C208,185.62,200.12,195.43,186.39,202.92Z';

export function setup(app: PiletApi) {
  app.registerExtension('library.header', () => (
    <app.Extension name="shared.dashboardHeader" params={{ screen: 'Library' }} />
  ));
  app.registerPage('/library', () => <app.Extension name="layout" params={{ layout: 'library', bind }} />);
  app.registerExtension('rail.entries', () => null, { id: 'library', title: 'Library', to: '/library', icon: DATABASE, order: 60 });
}
